import { AgentAccountWebService } from '@linktivity/gds-neo';

type contractedSuppliersStatus =
  AgentAccountWebService.GetContractedSuppliersStatusEnum;
const contractedSuppliersStatus =
  AgentAccountWebService.GetContractedSuppliersStatusEnum;

export { contractedSuppliersStatus };
